<template>
  <div class="relative min-h-screen">
    <!-- Location Bar -->
    <div class="flex justify-center items-center h-10 w-full bg-blue-400 text-white">
      <i class="material-icons text-blue-500">location_on</i>
      <span class="mx-24">{{ address }}</span>
      <span
        class="cursor-pointer underline"
        @click="$router.push({ name: 'stations', params: { showLocationEditor: true } })"
      >
        Edit
      </span>
    </div>

    <section class="flex items-center justify-center py-6 flex-col md:flex-row" v-if="!isFirst">
      <div class="flex items-center bg-gray-400 w-96 py-3 px-4">
        <i class="material-icons text-black">search</i>
        <input
          v-model="searchText"
          class="bg-gray-400 flex-grow outline-none ml-4"
          placeholder="Search"
          @input="isTyping = true"
        />
      </div>
    </section>

    <div class="flex justify-center" v-if="isLoading">
      <bar-loader
        class="my-8"
        color="#4db1fa"
        :width="320"
      />
    </div>

    <section class="flex-grow w-full pb-36" v-if="!isFirst">
      <div
        class="flex items-center bg-gray-400 mt-1 h-32 px-8 py-4"
        v-for="post in posts"
        :key="post.id"
      >
        <img class="w-24 mr-10" :src="post.image">

        <div class="ml-4 mr-12 flex-grow">
          <p class="text-lg text-black font-medium">{{ post.name }}</p>
          <p class="text-sm text-black">{{ post.address }}</p>
          <p
            class="post-body text-sm text-black"
          >
            {{ post.location }}
          </p>
        </div>

        <button
          class="btn h-12 w-48 flex-none"
          @click="showModal(post.id)"
        >
          Contact
        </button>

        <modal :name="`info-${post.id}`" :scrollable="true" width="700px" height="auto">
          <div class="p-6">
            <div class="py-2 flex justify-between">
              <div class="flex items-center w-1/5">
                <button @click="$modal.hide(`info-${post.id}`)" class="focus:outline-none flex items-center">
                  <i class="material-icons text-5xl text-black">keyboard_arrow_left</i>
                </button>
              </div>
              <h3 class="text-center text-xl font-bold flex w-3/5 items-center justify-center">{{post.name}}</h3>
              <div class="w-1/5"></div>
            </div>
            <!-- image -->
            <div class="py-10 flex items-center justify-center">
              <img class="w-40 h-40 object-cover border" :src="post.image">
            </div>
            <!-- buttons -->
            <div class="flex">
              <div class="px-2 flex-1">
                <a :href="`tel:${post.phone}`" class="flex bg-blue-400 py-2 px-3 text-white text-sm w-full justify-center items-center">
                  <i class="material-icons text-base text-black pr-2">phone</i>
                  <div class="flex text-center">{{ post.phone }}</div>
                </a>
              </div>
              <div class="px-2 flex-1">
                <a :href="`mailto:${post.email}`" class="flex bg-blue-400 py-2 px-3 text-white text-sm w-full justify-center items-center">
                  <i class="material-icons text-base text-black pr-2">email</i>
                  <div class="flex text-center">{{ post.email }}</div>
                </a>
              </div>
              <div class="px-2 flex-1">
                <a :href="post.website" target="_blank" class="flex bg-blue-400 py-2 px-3 text-white text-sm w-full justify-center items-center">
                  <i class="material-icons text-base text-black pr-2">language</i>
                  <div class="flex text-center">{{ post.website }}</div>
                </a>
              </div>
            </div>
            <!-- description -->
            <div class="px-8 py-10">
              <div class="bg-gray-400 p-6 text-sm">
                {{ post.description }}
              </div>
            </div>

          </div>
        </modal>

      </div>
    </section>

    <base-footer class="absolute bottom-0" />

  </div>
</template>


<script>
import { mapState } from 'vuex';
// import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import FirmService from '@/services/FirmService';

export default {
  data() {
    return {
      posts: [],
      searchText: '',
      currentPage: 1,
      lastPage: 1,
      isFirst: true,
      isLoading: true,
      isTyping: false,
    };
  },
  computed: {
    ...mapState('profile', ['address']),
  },
  watch: {
    searchText: debounce(function() {
      this.isTyping = false;
    }, 1000),

    currentPage: {
      immediate: true,
      async handler() {
        await this.fetch();
      },
    },

    async isTyping(value) {
      if (!value) {
        this.isLoading = true;

        if (this.currentPage === 1) {
          await this.fetch(false);
        } else {
          this.currentPage = 1;
        }
      }
    },

    async address() {
      if (this.currentPage === 1) {
        await this.fetch(false);
      } else {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    async fetch(append = true) {
      const { data: { data, meta } } = await FirmService.fetch({
        params: {
          q: this.searchText,
          page: this.currentPage,
          location: this.address,
        },
      });

      this.posts = append ? this.posts.concat(data) : data;
      this.lastPage = meta.last_page;

      if (this.isFirst) {
        this.isFirst = false;
      }

      this.isLoading = false;
    },

    showModal(id){
      this.$modal.show(`info-${id}`)
    },

    nextPage() {
      if (this.currentPage === this.lastPage) {
        return;
      }
      this.currentPage++;
    },

  },
  created() {
    this.$parent.$on('scroll_ended', this.nextPage);
  },
}
</script>
